import API from "../../../util/API";

const VOUCHER_API_BASE = "/vouchers";

export const voucherService = {
  /**
   * Get all vouchers with pagination
   */
  getAllVouchers: async (page = 1, limit = 10) => {
    try {
      const response = await API.get(`${VOUCHER_API_BASE}/admin?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch vouchers:", error);
      throw error;
    }
  },

  /**
   * Get single voucher by ID
   */
  getVoucherById: async (id) => {
    try {
      const response = await API.get(`${VOUCHER_API_BASE}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch voucher:", error);
      throw error;
    }
  },

  /**
   * Create new voucher
   */
  createVoucher: async (voucherData) => {
    try {
      const response = await API.post(`${VOUCHER_API_BASE}`, voucherData);
      return response.data;
    } catch (error) {
      console.error("Failed to create voucher:", error);
      throw error;
    }
  },

  /**
   * Update voucher
   */
  updateVoucher: async (id, voucherData) => {
    try {
      const response = await API.put(`${VOUCHER_API_BASE}/${id}`, voucherData);
      return response.data;
    } catch (error) {
      console.error("Failed to update voucher:", error);
      throw error;
    }
  },

  /**
   * Delete voucher
   */
  deleteVoucher: async (id) => {
    try {
      const response = await API.delete(`${VOUCHER_API_BASE}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to delete voucher:", error);
      throw error;
    }
  },

  /**
   * Apply voucher to cart
   */
  applyVoucher: async (code, cartId, userId) => {
    try {
      const response = await API.post(`${VOUCHER_API_BASE}/apply`, {
        code,
        cartId,
        userId,
      });
      return response.data;
    } catch (error) {
      console.error("Failed to apply voucher:", error);
      throw error;
    }
  },
};
